import "./confirmationStep.styles.scss";
import { AnimatedCheckmark } from "@alpaca/framework";

const ConfirmationStep = ({ mode }) => {
  return (
    <div className="confirmation__step__container">
      {mode === "invite" ? (
        <div>
          <AnimatedCheckmark
            headline="Invitations Sent!"
            description="Emails have been sent to your invitees"
          />
          {/* <h1 className="sectionHeading">Invitations Sent!</h1>
          <h3 className="bodyTextLarge">
           
          </h3> */}
        </div>
      ) : (
        <div>
          <h1>User Created!</h1>
        </div>
      )}
    </div>
  );
};

export default ConfirmationStep;
